<button class="lingo-fn-btn" [matTooltip]="tooltip">
  <img class="lingo-fn-logo" alt="Lingo AI" [src]="logoSrc" />
</button>
